import { useCallback } from 'react'
import { fetchOptions } from 'src/mentor/services/emrOptionsApi'

/**
 * Custom hook to create an async options loader for AsyncPaginate
 * @param {Object} field - The field definition containing optionSource
 * @param {string} defaultQueryName - Default query name if not specified in field
 * @param {number} pageSize - Number of options to fetch (default: 50)
 * @returns {Function} Async function to load options
 */
export function useLoadOptions(field, defaultQueryName, pageSize = 50) {
  return useCallback(
    async (inputValue) => {
      const options = await fetchOptions(
        field?.optionSource?.queryName || defaultQueryName,
        inputValue,
        {},
        pageSize,
      )

      return {
        options: options.map((opt) => ({
          value: opt.value,
          label: opt.label,
        })),
        hasMore: false,
      }
    },
    [field?.optionSource?.queryName, defaultQueryName, pageSize],
  )
}
